import { Grid } from "@mui/material";
import { crudGetList, ListContextProvider, RecordContextProvider, ReduxState, ResourceComponentPropsWithId } from "ra-core";
import { FC, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermit } from "@/authProvider/useHasPermit";
import { Content } from "@/components/content/Content";
import DatabaseSelectionCard from "@/components/obfuscation/DatabaseSelectionCard";
import TablesOwnershipList from "@/components/obfuscation/TablesOwnershipList";
import { TablesOwnershipContextProvider, useTablesOwnershipController } from "@/components/obfuscation/useTablesOwnershipContext";
import { EDIT_DATA_OWNERSHIP } from "@/constants";
import { RecPatch } from "@/dataProvider/tools";
import { DatabaseOwnershipStatsDto } from "@/gen/api/governance";
import { decodeHashid } from "@/utils/hashid";
import { pages, sorts } from "@/utils/paramsWithGetMainList";


const EditTablesOwnership: FC<ResourceComponentPropsWithId> = ({
  id: hId,
  resource,
  options,
}) => {
  const hasWritePermit = useHasPermit([EDIT_DATA_OWNERSHIP])
  const id = decodeHashid(hId || '')
  const dbOwnerships = useSelector<ReduxState, Record<number, DatabaseOwnershipStatsDto&RecPatch>>(store => store.admin.resources[resource || 'noop']?.data)
  const listCtx = useMemo(() => ({ data: dbOwnerships || {} }), [dbOwnerships])

  const currDb = dbOwnerships && dbOwnerships[id]

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(crudGetList(resource || 'noop', pages(), sorts(), {}))
  }, [resource, dispatch])

  const { ownershipCtx, ownershipListCtx } = useTablesOwnershipController({ databaseId: id })
  const { onUnselectItems } = ownershipListCtx

  useEffect(() => () => {
    onUnselectItems()
  }, [onUnselectItems])

  return (
    <Content
      pageName={hasWritePermit ? "Edit Ownership" : "Ownership Detail"}
      resourceName={hasWritePermit ? "Edit" : "View"}
      breadcrumbs={[ ...(options?.breadcrumbs || []), { label: 'Data Ownership', path: `/${resource}` } ]}
    >
      <RecordContextProvider value={currDb}>
        <TablesOwnershipContextProvider value={ownershipCtx}>

          <Grid container spacing={4}>
            <Grid item xs={12}>
              <ListContextProvider value={listCtx}>
                <DatabaseSelectionCard />
              </ListContextProvider>
            </Grid>
            <Grid item xs={12}>
              <ListContextProvider value={ownershipListCtx}>
                <TablesOwnershipList />
              </ListContextProvider>
            </Grid>
          </Grid>
        </TablesOwnershipContextProvider>
      </RecordContextProvider>
    </Content>
  )
}

export default EditTablesOwnership;
